// Utility functions for generating and handling branded room links

import { createRoomInviteLink } from '../utils/inviteLink';

export function generateRoomLink(roomId: string, joinCode: string): string {
  return createRoomInviteLink(roomId, joinCode);
}

export function parseRoomCodeFromLink(url: string): string | null {
  try {
    const codeMatch = url.match(/[?&]code=([A-Z0-9]{4,10})/i);
    if (codeMatch?.[1]) {
      return codeMatch[1].toUpperCase();
    }

    const pathMatch = url.match(/\/join\/room\/[^/?#]+/i);
    if (pathMatch) {
      return null;
    }

    const legacyMatch = url.match(/join[/?](?:room=)?([A-Z0-9]{4,10})/i);
    return legacyMatch ? legacyMatch[1].toUpperCase() : null;
  } catch {
    return null;
  }
}
